import React from 'react';
import { Menu, ActionIcon } from '@mantine/core';
import { IconLanguage } from '@tabler/icons-react';
import { useI18n, Locale } from '../../locales/i18n-context';

export const LanguageSelector: React.FC = () => {
  const { setLocale, t } = useI18n();

  return (
    <Menu shadow="md" width={160}>
      <Menu.Target>
        <ActionIcon variant="subtle" color="gray" title={t('header.selectLanguage')}>
          <IconLanguage size={18} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={() => setLocale('en' as Locale)}>🇺🇸 English</Menu.Item>
        <Menu.Item onClick={() => setLocale('pt-BR' as Locale)}>🇧🇷 Português</Menu.Item>
        <Menu.Item onClick={() => setLocale('es' as Locale)}>🇪🇸 Español</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
